const baseUrl = import.meta.env.VITE_API_BASE_URL ?? '/';

function versionApiPath(path: string): string {
  if (path.startsWith('api/v1/')) return path;
  if (path.startsWith('api/')) return path.replace(/^api\//, 'api/v1/');
  return path;
}

/**
 * Resolve an API path against VITE_API_BASE_URL.
 *
 * The base may be absolute (e.g. `http://api.test`) or root-relative (the dev
 * default `/`). `new URL(path, '/')` throws because the URL constructor requires
 * an absolute base, so a root-relative base is first anchored to the current
 * origin. This keeps dev (same-origin via the Vite proxy) and tests/e2e
 * (absolute base) on the same code path.
 */
export function apiUrl(path: string): string {
  const base = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
  const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
  const normalizedPath = versionApiPath(path.replace(/^\//, ''));
  return new URL(normalizedPath, new URL(base, origin)).toString();
}
